module.exports = __webpack_public_path__ + "media/images/map_icons/Boxing-afd548b0d61f9298019367716cd5db3e.svg";